// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panel-top-dashed.js';

import { paths } from '../generated/panel-top-dashed';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panel-top-dashed', Original, paths);
